"use client";

import { useEffect, useState } from "react";
import { Ico32Talk } from "@/shared/assets/icons/ico_32_talk";
import { useTranslations } from "next-intl";
import { usePathname, useRouter } from "next/navigation";

interface FloatingButtonProps {
  text?: string;
  href?: string;
  onClick?: () => void;
  scrollThreshold?: number;
}

export function FloatingButton({ text = "도입상담 신청", href, onClick, scrollThreshold = 100 }: FloatingButtonProps) {
  const [isVisible, setIsVisible] = useState(false);
  const [isFooterVisible, setIsFooterVisible] = useState(false);
  const t = useTranslations();
  const pathname = usePathname();
  // 메인페이지에서만 표시
  const isMainPage = pathname === "/";
  const router = useRouter();

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY;
      setIsVisible(scrolled > scrollThreshold);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrollThreshold]);

  useEffect(() => {
    const footer = document.querySelector(".footer");
    if (!footer) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsFooterVisible(entry.isIntersecting);
      },
      { threshold: 0 },
    );

    observer.observe(footer);
    return () => observer.disconnect();
  }, []);

  if (!isMainPage) {
    return null;
  }

  return (
    <button
      className={`body-lg-bold pc:text-[16px] bg-primary-500 drop-shadow-[0_2px_8px_rgba(0, 0, 0, 0.12)] tb:size-30 pc:right-20 tb:right-10 tb:whitespace-normal fixed right-4 z-50 flex size-22.5 cursor-pointer flex-col items-center justify-center gap-[6px] rounded-full text-[13px] whitespace-pre-line text-white transition-all duration-300 ${
        isFooterVisible ? "pc:bottom-[235px] tb:bottom-[273px] bottom-[370px]" : "bottom-15"
      } ${isVisible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"}`}
      onClick={() => router.push("/inquiry")}
    >
      <Ico32Talk className="tb:size-8 size-6" />
      {t("fb_btn")}
    </button>
  );
}
